module.exports = __webpack_public_path__ + "static/media/pricesIco.9bfe2929.svg";